import type { CaregiverRelationshipKind } from '../../../__generated__/globalTypes';
import type { IDependentDateOfBirth } from '../../../lib/dependents/helpers';

export type { IDependentDateOfBirth };

export interface IDependentFormValues {
  relationship: CaregiverRelationshipKind | null;
  isStep: boolean;
  isInLaw: boolean;
  firstName: string;
  lastName: string;
  preferredName: string;
  dateOfBirth: IDependentDateOfBirth | null;
}

export const createEmptyDependentFormValues = (): IDependentFormValues => ({
  relationship: null,
  isStep: false,
  isInLaw: false,
  firstName: '',
  lastName: '',
  preferredName: '',
  dateOfBirth: null,
});
